module.exports = __webpack_public_path__ + "img/StartSWBanner_line-1.95b92206.png";